import AuthContext from "context/AuthContext";
import { useContext } from "react";
import ContainerFilter from "./waste/ContainerFilter"
import ContainerFiltersBridge from "./bridge/ContainerFiltersBridge"

const ContainerFiltersManager = ({ filters, params, applyFilters, setItemsShown, isLoading, orderingRef }) => {
    const { panel } = useContext(AuthContext);
    switch (panel.panel_type) {
        case 'b':
            return (
                <>
                    <ContainerFiltersBridge
                        filters={filters}
                        params={params}
                        applyFilters={applyFilters}
                        setItemsShown={setItemsShown}
                        isLoading={isLoading}
                        orderingRef={orderingRef}
                    />
                </>
            );
        default:
            return (
                <>
                    <ContainerFilter
                        filters={filters}
                        params={params}
                        applyFilters={applyFilters}
                        setItemsShown={setItemsShown}
                        isLoading={isLoading}
                        orderingRef={orderingRef}
                    />
                </>
            );
    }
};

export default ContainerFiltersManager;